import React, {
  useMemo,
} from 'react';

import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
} from 'reactflow';

const WorkflowCustomEdgeNoEditable = ({ edge, config }) => {

  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
    markerStart,
    style = {}
  } = edge;

  const { type } = config;

  const isDirectionalEdge = useMemo(() => {
    return type == 'directional';
  }, [edge])

  const isBidirectionalEdge = useMemo(() => {
    return type == 'bidirectional';
  }, [edge])

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={isBidirectionalEdge ? markerStart : ''}
        style={style}

      />
      <EdgeLabelRenderer></EdgeLabelRenderer>
    </>
  );
}

export default React.memo(WorkflowCustomEdgeNoEditable);
